import Component from "./training.component";
import { Config } from "./training.config";
import { watchTraining as saga } from "./redux/training.sagas";
import { reducer } from "./redux/training.reducer";

export default { Component, saga, reducer, config: Config };
